import { defineStore } from "pinia";
import {
  ROOM_PREVIEW_PRE_EVENT,
  normalizeRoomPreviewState,
} from "%/dynamic-component-editor/helpers/event-room-preview-states";

// Edit-time-only preview state, deliberately a store rather than a DC option:
// an option mis-homed between the element and root trees reads as undefined.
export const useEventRoomPreviewStore = defineStore("event-room-preview-store", {
  state: () => ({
    previewState: ROOM_PREVIEW_PRE_EVENT,
  }),
  actions: {
    setPreviewState(state) {
      this.previewState = normalizeRoomPreviewState(state);
    },
  },
});
